import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { modelOf } from '../../../prop-types';
import ProductStore from '../../../store/ProductStore';
import ProductSlider from '../ProductSlider';
import Product from '../../../models/Product';
import RequestState from '../../../types/RequestState';
import ContentForState from '../../loader/ContentForState';
import { ViewBreakpointMinWidth } from '../../../types/ViewBreakpoint';

const SLIDER_SETTINGS = {
  cartModal: {
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: ViewBreakpointMinWidth.XXL,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: ViewBreakpointMinWidth.XL,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: ViewBreakpointMinWidth.MD,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: ViewBreakpointMinWidth.SM,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  },
  default: {}
};

const CARD_SETTINGS = {
  cartModal: {
    hideDescription: true,
    hideProperties: true,
    requireCanonicalLink: true,
    productImageSettings: {
      overrideConfigStoreAspectRatio: true,
      customAspectRatio: '100'
    }
  },
  default: {}
};

@observer
export class AlsoPurchasedProductsSlider extends Component {
  listName = 'Also Purchased Products';

  componentDidMount() {
    this.loadProductIds();
  }

  loadProductIds = () => {
    const { product, forceRefresh } = this.props;

    if (product.alsoPurchasedState === RequestState.NONE || forceRefresh) {
      product
        .loadAlsoPurchased(product.id)
        .then(() => {
          this.loadMissingProducts();
        })
        .catch((e) => {
          if (e.response && e.response.status !== 404) {
            console.error(e);
          }
        });
    }
  };

  loadMissingProducts = () => {
    const { productStore, product } = this.props;
    if (product.alsoPurchasedIds.length > 0) {
      productStore.loadProducts(
        {
          ids: product.alsoPurchasedIds.slice()
        },
        true
      );
    }
  };

  getSliderSettings = () => {
    const { variant } = this.props;

    if (SLIDER_SETTINGS[variant]) {
      return SLIDER_SETTINGS[this.props.variant];
    }

    return SLIDER_SETTINGS['default'];
  };

  getCardSettings = () => {
    const { variant } = this.props;

    if (CARD_SETTINGS[variant]) {
      return CARD_SETTINGS[this.props.variant];
    }

    return CARD_SETTINGS['default'];
  };

  getProducts = () => {
    const { productStore, product } = this.props;

    if (product.alsoPurchasedIds.length === 0) {
      return null;
    }

    const products = product.alsoPurchasedIds
      .filter((productId) => productStore.products.has(productId))
      .map((productId) => productStore.products.get(productId));

    if (products.length === 0) {
      return null;
    }
    return products;
  };

  render() {
    const { product } = this.props;
    const products = this.getProducts();

    if (!products) {
      return null;
    }

    return (
      <ContentForState
        state={product.alsoPurchasedState}
        forLoaded={() => {
          return (
            products && (
              <div className="AlsoPurchasedProductsSlider">
                <h3 className="AlsoPurchasedProductSlider__title">
                  <FormattedMessage
                    id="product.alsoPurchasedProducts"
                    defaultMessage="Customers who purchased this item, also purchased"
                  />
                </h3>
                <ProductSlider
                  settings={this.getSliderSettings()}
                  cardSettings={this.getCardSettings()}
                  name={this.listName}
                  products={products}
                />
              </div>
            )
          );
        }}
      />
    );
  }
}

AlsoPurchasedProductsSlider.propTypes = {
  productStore: modelOf(ProductStore).isRequired,
  product: modelOf(Product).isRequired,
  variant: PropTypes.string.isRequired,
  forceRefresh: PropTypes.bool
};

AlsoPurchasedProductsSlider.defaultProps = {
  variant: 'default'
};

export default inject('productStore')(AlsoPurchasedProductsSlider);



// WEBPACK FOOTER //
// ./src/components/slider/AlsoPurchasedProductsSlider/index.jsx